import { useEffect, useState } from "react";
import Massage from "../../design/Massage";
import { useSearchParams } from "react-router-dom";

function FilterFlightsData({ data, openNumDocket, deleteAufaData }) {
    const [isAdmin, setIsAdmin] = useState(false)
    const [message, setMessage] = useState({ open: false, textData: '', deleteValues: null });
    // console.log("FilterFlightsData", data);

    useEffect(() => {
        const admin = sessionStorage.getItem('admin') === 'admin';
        setIsAdmin(admin);
    }, [])

    const handleDelete = () => {
        deleteAufaData(message.deleteValues)
        setMessage({ open: false, textData: '', deleteValues: null });
    }

    return (<>
        {
            data.length > 0 ?

                <div className={"filter-flights-table"}>
                    <table>
                        <thead>
                            <tr>
                                {
                                    ["מס'", "שם פרטי", "שם משפחה", "מחיר", "מס' דוקט", "אושר", "מחיקה"].map((value, key) => (
                                        <th key={key}> {value} </th>
                                    ))
                                }
                            </tr>
                        </thead>

                        <tbody>
                            {
                                data.map((value, key) => (
                                    <tr key={key}>
                                        <td> {key + 1} </td>
                                        <td> {value["firstName"]} </td>
                                        <td> {value["lastName"]} </td>
                                        <td> {value["price"]}$ </td>
                                        <td onClick={() => openNumDocket(value["docket"])} className="docket_number"> {value["docket"]} </td>
                                        <td> {value["app"] ? "אושר" : "ממתין"} </td>
                                        {isAdmin && (
                                            <td>
                                                <button onClick={() => { setMessage({ open: true, textData: `${value["firstName"]} ${value["lastName"]}`, deleteValues: value }); }}>
                                                    מחק
                                                </button>
                                            </td>
                                        )}
                                    </tr>
                                ))
                            }
                        </tbody>

                    </table>
                </div>

                :
                <p className={"no-results"}>אין תוצאות</p>
        }
        {message.open ? (<Massage
            text={`האם אתה בטוח שברצונך למחוק את הזמנתו של ${message.textData}? שים לב! מחיקה זו הינה מחיקת נתונים בלבד. למחיקה מלאה היכנס לדוקט`}
            buttonAgree={() => { handleDelete() }}
            setClose={() => setMessage({ open: false, textData: '', deleteValues: '' })}
        />) : ''}


    </>)
}


export default FilterFlightsData;